export default "__VITE_ASSET__BuF5Em3Y__"